/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateCenterChildBalanceDto } from '../../models/update-center-child-balance-dto';

export interface UserCenterChildControllerUpdateBalance$Params {
  id: string;
      body: UpdateCenterChildBalanceDto
}

export function userCenterChildControllerUpdateBalance(http: HttpClient, rootUrl: string, params: UserCenterChildControllerUpdateBalance$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, userCenterChildControllerUpdateBalance.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

userCenterChildControllerUpdateBalance.PATH = '/api/center-child/user/{id}/balance';
